import { Popover } from '@localagent/ui';
import { FileWorkItemTrail } from '../work/FileWorkItemTrail';

export function FileHistoryButton({ workspaceId, path }: { workspaceId: string; path: string }) {
  return (
    <Popover
      align="end"
      portal
      aria-label="File history"
      triggerClassName="px-2 py-1 text-caption text-muted-foreground hover:text-foreground"
      contentClassName="w-72 p-3"
      trigger={<span data-testid="file-history-button">History</span>}
    >
      <div data-testid="file-history-popover">
        <FileWorkItemTrail workspaceId={workspaceId} path={path} />
      </div>
    </Popover>
  );
}
